import { useObserver } from "mobx-react";
import { useStores } from "../../store";
import { useEffect } from "react";
// import Checkbox from "../JobPost/Checkbox";
import Checkbox2 from "../JobPost/Checkbox2";

export default function ApplicationProgress({ props }) {
  const { CommonStore } = useStores();
  let isMobile = false;
  function getFirstWord(item) {
    if (item === "Technical interview") {
      return "Tech";
    }
    return item.split(" ")[0];
  }
  useEffect(() => {
    if (window.innerWidth < 1000) {
      isMobile = true;
    }
  }, []);

  return useObserver(() => (
    <>
      <div className="w-fit mx-auto my-auto  py-1 rounded-lg flex md:pl-20 items-center lg:pl-20 pl-3 ml-4 ">
        {/* <h1 className="text-primary font-bold text-xl ">Create new Chatbot </h1> */}
        <div
          className={`flex justify-center items-center md:w-[80%] lg:w-[90%] w-[30%] ${
            CommonStore.ApplicationProgress[1].hidden ||
            CommonStore.ApplicationProgress[2].hidden ||
            CommonStore.ApplicationProgress[3].hidden
              ? "gap-10"
              : "gap-7"
          } md:mx-0 lg:mx-0 checkbox-container  ${
            CommonStore.ApplicationProgress1 > 0 ? "first" : ""
          } ${CommonStore.ApplicationProgress1 > 1 ? "sec" : ""} ${
            CommonStore.ApplicationProgress1 > 2 ? "third" : ""
          }  ${CommonStore.ApplicationProgress1 > 3 ? "fourth" : ""}  `}
        >
          {CommonStore.ApplicationProgress.map((item, index) => (
            <>
              {item.hidden ? null : (
                <div className={`relative  items-center flex h-16 `}>
                  <Checkbox2
                    label={
                      window.innerWidth < 1000
                        ? getFirstWord(item.item)
                        : item.item
                    }
                    active={item.isActive}
                    completed={
                      item.item === "Applied" || item.completed
                        ? true
                        : CommonStore.ApplicationProgress1 > index
                    }
                    ind={index}
                    hired={item.hired}
                    rejected={item.rejected}
                  />
                </div>
              )}
            </>
          ))}
          {/* <div className="relative w-1/4 ">
          <Checkbox label="Basic Information" completed={true} />
        </div>
        <div className="relative w-1/4">
          <Checkbox
            label="chatbot settings"
            completed={CommonStore.progress > 0}
          />
        </div>
        <div className="relative w-1/4">
          <Checkbox label="Lead Info" completed={CommonStore.progress > 1} />
        </div>
        <div className="relative w-1/4">
          <Checkbox
            label="chatbot preview"
            completed={CommonStore.progress > 2}
          />
        </div> */}
        </div>
      </div>
    </>
  ));
}
